import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Container, Row, InputGroup } from 'react-bootstrap';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { BiUser } from "react-icons/bi";
import { useDispatch } from "react-redux";
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";
import { FaEye, FaEyeSlash } from 'react-icons/fa6';
import { config } from '../Components/CommonUtilities/CommonUrl/CommonUrls';
import axios from 'axios';
import { TfiReload } from 'react-icons/tfi';
import { CommomLoginAunthenticatePost, CommonAxiosGet } from '../Components/CommonUtilities/CommonAxios/CommonAxios';
import Sweetalert from '../Components/CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { ERROR_MSG, USERNAME_REG } from '../Components/CommonUtilities/Validations/RegularExpAndVar';

const userValidationSchema = Yup.object().shape({
  username: Yup.string().required(ERROR_MSG),
  password: Yup.string().required(ERROR_MSG),
  captcha: Yup.string().required(ERROR_MSG),
});

export const initialFormValues = {
  username: "",
  password: "",
  captcha: "",
  captchaId: ""
};

// Utility to handle logout
export const handleLogout = (dispatch, navigate) => {
  dispatch({ type: "SHOW_LOGIN_DETAILS", payload: {} });
  dispatch({ type: "SHOW_TAB_DETAILS", payload: {} });

  window.sessionStorage.removeItem('token');
  Cookies.remove("token");
  Cookies.remove("refreshToken");
  localStorage.clear();
  navigate("/");
};

// Utility to fetch captcha
const fetchCaptcha = async (setRefreshCaptcha, formik) => {
  try {
    const url = config.url.DSC_URL + "dsc-public/generate-captcha";
    const res = await axios.post(url);
    if (res?.data?.status === true) {
      setRefreshCaptcha(res.data.captcha);
      formik.setFieldValue('captchaId', res.data.captchaId);
      formik.setFieldValue('captcha', "");
    }
  } catch (error) {
    console.error("Error fetching captcha", error);
  }
};

// Utility to authenticate user
const authenticateUser = async (values, navigate, dispatch, setRefreshCaptcha, formik) => {
  try {
    const url = config.url.DSC_URL + "auth/emp-authenticate";
    const res = await CommomLoginAunthenticatePost(url, values);
    if (res.data.scode === "01") {
      const decoded = jwtDecode(res.data.access_token);
      const tokenExpiry = new Date(decoded.exp * 1000);
      const refreshExpiry = new Date(jwtDecode(res.data.refresh_token).exp * 1000);
      Cookies.set("token", res.data.access_token, { expires: tokenExpiry });
      Cookies.set("refreshToken", res.data.refresh_token, { expires: refreshExpiry });

      dispatch({
        type: "SHOW_LOGIN_DETAILS",
        payload: {
          isLoggedIn: true, loginData: decoded, userType: res.data.user_type, roleServices: res?.data?.services_list,
          isLoginActive: decoded?.login_active,
        }
      });
      if (decoded?.role_id === 8) {
        navigate('/AddService')
      }
      if (decoded?.role_id === 7 || decoded?.role_id === 4 || decoded?.role_id === 6) {
        navigate('/CasteWiseAdequacy')
      }
      else if (decoded?.role_id === 5 || decoded?.role_id === 7) {
        navigate('/AdequacyConfirmation')
      }
      else if (decoded?.role_id === 9) {
        navigate('/datewiseapplicationsReport')
      }
      else if (decoded?.role_id === 10) {
        navigate('/DistwiseCandidatesReport')
      }
    } else {
      fetchCaptcha(setRefreshCaptcha, formik);
      Sweetalert(res.data.sdesc, 'error');
    }
  } catch (error) {
    console.error("Login error", error);
  }
};

// Fetch initial data for tab status
const getData = async (dispatch, navigate) => {
  const url = config.url.DSC_URL + "tab-status";
  try {
    const res = await CommonAxiosGet(url);
    if (res?.data?.status === true) {
      const latestTab = res?.data?.tabdata_status ? parseInt(res?.data?.tabdata[0]?.current_tab) : 1;
      const confirmation = res?.data?.confirmation_status ? res?.data?.confirmation[0]?.basic_education_check : false;

      dispatch({ type: "SHOW_TAB_DETAILS", payload: { latestTab, confirm: confirmation } });

      if (latestTab === 4) {
        navigate('/PrintApplication');
      } 
      // else {
      //   navigate("/ProfileDetailsWay");
      // }
    }
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

// Main component
export default function EmployeeLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showUserPwd, setShowUserPwd] = useState(true);
  const [refreshCaptcha, setRefreshCaptcha] = useState("");

  const formik = useFormik({
    initialValues: initialFormValues,
    validationSchema: userValidationSchema,
    onSubmit: (values) => authenticateUser(values, navigate, dispatch, setRefreshCaptcha, formik)
  });

  useEffect(() => {
    fetchCaptcha(setRefreshCaptcha, formik);
    handleLogout(dispatch, navigate);
  }, [dispatch, navigate]);

  const togglePasswordVisibility = (id) => {
    const passwordInput = document.getElementById(id);
    passwordInput.type = passwordInput.type === "password" ? "text" : "password";
  };

  return (
    <FormikProvider value={formik}>
      <Row>
        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
          <div className=''>
            <p className='pt-1 pt-md-2'>Hello! Let’s get started</p>
            <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} >
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1" className="group_txt">
                  <BiUser className="font_size" />
                </InputGroup.Text>
                <Field
                  type="text"
                  name="username"
                  placeholder="Enter Your User Name"
                  className="input-field form-control"
                  maxLength='20'
                />
                <ErrorMessage name="username" component="div" className="text-error" />
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon2" className="group_txt">
                  {showUserPwd ? (
                    <FaEyeSlash className="font_size" onClick={() => { togglePasswordVisibility("pwd"); setShowUserPwd(false); }} />
                  ) : (
                    <FaEye className="font_size" onClick={() => { togglePasswordVisibility("pwd"); setShowUserPwd(true); }} />
                  )}
                </InputGroup.Text>
                <input
                  type="password"
                  placeholder="Password"
                  id='pwd'
                  name="password"
                  className="form-control"
                  maxLength='30'
                  autoComplete="off"
                  onChange={(e) => formik.setFieldValue('password', e.target.value)}
                />
                <ErrorMessage name="password" component="div" className="text-error" />
              </InputGroup>
              <InputGroup className="mb-3">
                <TfiReload onClick={() => fetchCaptcha(setRefreshCaptcha, formik)} size={20} className="mt-2" />
                &nbsp;
                <img height={40} width={100} src={refreshCaptcha} alt="captcha" />
                &nbsp;&nbsp;
                <Field
                  className="form-control"
                  type="text"
                  name="captcha"
                  placeholder="Captcha"
                  maxLength="6"
                  autoComplete="off"
                />
                <ErrorMessage name="captcha" component="div" className="text-error" />
              </InputGroup>
              <Button variant="" type="submit" className='w-100 sign-in-button'>
                Sign in
              </Button>
            </Form>

          </div>
        </Col>

      </Row>
    </FormikProvider>
  );
}
